@if (!this.roleService.isQuickapi();) {
  <app-header></app-header>
}
@if (this.roleService.isQuickapi();) {
  <app-header-quickapi></app-header-quickapi>
}
<router-outlet></router-outlet>

<app-to-top></app-to-top>
<app-footer></app-footer>
